import { Box } from "@mui/system";
import FtdTabs from "./FtdTabs";

// 5+ Clicks with 0 FTD and Problematic FTDs are fetched independently by
// their own sub-tab (see ClicksWithFtd.tsx / ProblematicFtds.tsx) — this
// parent no longer fetches anything itself, so only the sub-tab the user
// actually opens triggers its API call.
const Ftd = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <FtdTabs />
      </Box>
    </>
  );
};

export default Ftd;
